"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var errorReporting = _interopRequireWildcard(require("./utils/fetch/errorReporting"));

var format = _interopRequireWildcard(require("./utils/format"));

var htmlInputValidation = _interopRequireWildcard(require("./utils/html-input-validation"));

var performance = _interopRequireWildcard(require("./utils/performance"));

var _Button = _interopRequireDefault(require("./components/Button/Button"));

var _ClientTimer = _interopRequireDefault(require("./utils/timer/ClientTimer"));

var _ConditionalComponent = _interopRequireDefault(require("./components/ConditionalComponent/ConditionalComponent"));

var _ExpandableSection = _interopRequireDefault(require("./components/ExpandableSection/ExpandableSection"));

var _Form = _interopRequireDefault(require("./components/Form/Form"));

var _FormOptions = _interopRequireDefault(require("./components/FormOptions/FormOptions"));

var _FormSelect = _interopRequireDefault(require("./components/FormSelect/FormSelect"));

var _FormTextArea = _interopRequireDefault(require("./components/FormTextArea/FormTextArea"));

var _FormTextField = _interopRequireDefault(require("./components/FormTextField/FormTextField"));

var _ProgressMeter = _interopRequireDefault(require("./components/ProgressMeter/ProgressMeter"));

var _constants = require("./config/constants");

var _Text = _interopRequireDefault(require("./components/Text/Text"));

var _applyFileExtension = require("./utils/applyFileExtension");

var _delegate = require("./utils/events/delegate");

var _escape = require("./utils/expressions/escape");

var _generateId = require("./utils/generateId");

var _boolean = require("./utils/type-checks/boolean");

var _date = require("./utils/type-checks/date");

var _isDefined = require("./utils/misc-checks/isDefined");

var _function = require("./utils/type-checks/function");

var _number = require("./utils/type-checks/number");

var _isOfLength = require("./utils/misc-checks/isOfLength");

var _fetch = require("./utils/fetch");

var _tokenReplacement = require("./utils/tokenReplacement");

var _triggerCustom = require("./utils/events/triggerCustom");

var _useBreakpoint = require("./utils/react-hooks/useBreakpoint");

var _local = require("./utils/storage/local");

var _session = require("./utils/storage/session");

var _codec = require("./utils/codec");

var _array = require("./utils/type-checks/array");

var _object = require("./utils/type-checks/object");

var _string = require("./utils/type-checks/string");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

module.exports = {
  Button: _Button.default,
  ClientTimer: _ClientTimer.default,
  ConditionalComponent: _ConditionalComponent.default,
  ExpandableSection: _ExpandableSection.default,
  Form: _Form.default,
  FormOptions: _FormOptions.default,
  FormSelect: _FormSelect.default,
  FormTextArea: _FormTextArea.default,
  FormTextField: _FormTextField.default,
  ProgressMeter: _ProgressMeter.default,
  REQUEST_METHOD: _constants.REQUEST_METHOD,
  Text: _Text.default,
  applyFileExtension: _applyFileExtension.applyFileExtension,
  delegateEvent: _delegate.delegateEvent,
  errorReporting: errorReporting,
  expressions: {
    escape: _escape.escape
  },
  fromBase64: _codec.fromBase64,
  format: format,
  generateId: _generateId.generateId,
  htmlInputValidation: htmlInputValidation,
  isArray: _array.isArray,
  isArrayOfLength: _array.isArrayOfLength,
  isBoolean: _boolean.isBoolean,
  isDate: _date.isDate,
  isDefined: _isDefined.isDefined,
  isFunction: _function.isFunction,
  isNumber: _number.isNumber,
  isObject: _object.isObject,
  isObjectEqualShallow: _object.isObjectEqualShallow,
  isOfLength: _isOfLength.isOfLength,
  isString: _string.isString,
  isStringOfLength: _string.isStringOfLength,
  isUUIDv4: _string.isUUIDv4,
  parseJWT: _codec.parseJWT,
  performance: performance,
  sendRequest: _fetch.sendRequest,
  storage: {
    clearLocalStorage: _local.clearLocalStorage,
    clearSessionStorage: _session.clearSessionStorage,
    hasLocalStorage: _local.hasLocalStorage,
    hasSessionStorage: _session.hasSessionStorage
  },
  toBase64: _codec.toBase64,
  tokenReplacement: _tokenReplacement.tokenReplacement,
  triggerCustomEvent: _triggerCustom.triggerCustom,
  useBreakpoint: _useBreakpoint.useBreakpoint
};
